import React from 'react';
import { ReactComponent } from 'Common/components/Icons/head-protection.svg';

const HeadProtection = () => <ReactComponent className="MuiSvgIcon-root" />;

export default HeadProtection;
